import { useToast, TYPE } from 'vue-toastification';

const toast = useToast();
export class ToastService {
    default(msg: string): void {
        toast(msg, {
            type: TYPE.DEFAULT
        });
    }
    success(msg: string): void {
        toast(msg, {
            type: TYPE.SUCCESS
        });
    }
    warn(msg: string): void {
        toast(msg, {
            type: TYPE.WARNING
        });
    }
    error(msg: string): void {
        toast(msg, {
            type: TYPE.ERROR
        });
    }
    info(msg: string): void {
        toast(msg, {
            type: TYPE.INFO
        });
    }
    // eslint-disable-next-line
    normaliseVueValidatorErrors(errors: any): void {
        let error = '';
        let addEndline = errors.length;
        // eslint-disable-next-line
        errors.forEach((err: any) => {
            error += `• ${err.$message}`;
            addEndline--;
            if (addEndline > 0) {
                error += '\n';
            }
        });
        toast(error, {
            type: TYPE.WARNING
        });
    }
}
